// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_Jupiter_main-menu__E2lkE .Sidebar_Jupiter_fa__4G93R {
    position: relative;
    display: table-cell;
    width: 60px;
    height: 36px;
    text-align: center;
    vertical-align: middle;
    font-size: 18px;
  }
  
  
  .Sidebar_Jupiter_main-menu__E2lkE:hover,
  nav.Sidebar_Jupiter_main-menu__E2lkE.Sidebar_Jupiter_expanded__1QrQC {
    width: 60px;
    overflow: visible;
    background: #32879c;
  }
  
  .Sidebar_Jupiter_main-menu__E2lkE {
  
    position: fixed;
    top: 0;
    bottom: 0;
    height: 100%;
    left: 0;
    width: 2px;
    overflow: hidden;
    transition: width .05s linear;
    -webkit-transform: translateZ(0) scale(1, 1);
    z-index: 1000;
  }
  
  .Sidebar_Jupiter_main-menu__E2lkE>ul {
    margin: 7px 0;
  }
  
  .Sidebar_Jupiter_main-menu__E2lkE li {
    position: relative;
    display: block;
    width: 60px;
  }
  
  .Sidebar_Jupiter_main-menu__E2lkE li>a img {
    width: 25px;
  
  }
  
  .Sidebar_Jupiter_main-menu__E2lkE li>a {
    position: relative;
    display: table;
    border-collapse: collapse;
    border-spacing: 0;
    color: #fff;
    font-family: arial;
    font-size: 14px;
    text-decoration: none;
    -webkit-transform: translateZ(0) scale(1, 1);
    transition: all .1s linear;
    display: block;
    text-align: center;
    padding: 8px;
  
  }
  
  
  
  .Sidebar_Jupiter_main-menu__E2lkE .Sidebar_Jupiter_nav-text__PhzG4 {
    position: relative;
    display: table-cell;
    vertical-align: middle;
    width: 0px;
    font-family: 'Titillium Web', sans-serif;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Jupiter/DashboardMain_Jupiter/Sidebar_Jupiter.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;EACjB;;;EAGA;;IAEE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,MAAM;IACN,SAAS;IACT,YAAY;IACZ,OAAO;IACP,UAAU;IACV,gBAAgB;IAEhB,6BAA6B;IAC7B,4CAA4C;IAC5C,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;;EAEb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,4CAA4C;IAE5C,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;IAClB,YAAY;;EAEd;;;;EAIA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,wCAAwC;EAC1C","sourcesContent":[".main-menu .fa {\n    position: relative;\n    display: table-cell;\n    width: 60px;\n    height: 36px;\n    text-align: center;\n    vertical-align: middle;\n    font-size: 18px;\n  }\n  \n  \n  .main-menu:hover,\n  nav.main-menu.expanded {\n    width: 60px;\n    overflow: visible;\n    background: #32879c;\n  }\n  \n  .main-menu {\n  \n    position: fixed;\n    top: 0;\n    bottom: 0;\n    height: 100%;\n    left: 0;\n    width: 2px;\n    overflow: hidden;\n    -webkit-transition: width .05s linear;\n    transition: width .05s linear;\n    -webkit-transform: translateZ(0) scale(1, 1);\n    z-index: 1000;\n  }\n  \n  .main-menu>ul {\n    margin: 7px 0;\n  }\n  \n  .main-menu li {\n    position: relative;\n    display: block;\n    width: 60px;\n  }\n  \n  .main-menu li>a img {\n    width: 25px;\n  \n  }\n  \n  .main-menu li>a {\n    position: relative;\n    display: table;\n    border-collapse: collapse;\n    border-spacing: 0;\n    color: #fff;\n    font-family: arial;\n    font-size: 14px;\n    text-decoration: none;\n    -webkit-transform: translateZ(0) scale(1, 1);\n    -webkit-transition: all .1s linear;\n    transition: all .1s linear;\n    display: block;\n    text-align: center;\n    padding: 8px;\n  \n  }\n  \n  \n  \n  .main-menu .nav-text {\n    position: relative;\n    display: table-cell;\n    vertical-align: middle;\n    width: 0px;\n    font-family: 'Titillium Web', sans-serif;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main-menu": `Sidebar_Jupiter_main-menu__E2lkE`,
	"fa": `Sidebar_Jupiter_fa__4G93R`,
	"expanded": `Sidebar_Jupiter_expanded__1QrQC`,
	"nav-text": `Sidebar_Jupiter_nav-text__PhzG4`
};
export default ___CSS_LOADER_EXPORT___;
